// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3K_Bg","col":"styles_col__30dpJ"};